import { Component, ElementRef, ViewChild, AfterViewInit, ViewEncapsulation, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cursor',
  standalone: true,
  templateUrl: './cursor.html',
  styleUrl: './cursor.css',
  encapsulation: ViewEncapsulation.None
})
export class CursorComponent implements AfterViewInit {
  @ViewChild('cursor') cursorEl!: ElementRef<HTMLDivElement>;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;
    const cursor = this.cursorEl.nativeElement;
    cursor.style.opacity = '0';

    document.addEventListener('mousemove', (e: MouseEvent) => {
      cursor.style.transform = `translate(${e.clientX - 11}px, ${e.clientY - 27}px)`;
      cursor.style.opacity = '1';
    });

    document.addEventListener('mouseleave', () => {
      cursor.style.opacity = '0';
    });

    document.addEventListener('mouseenter', () => {
      cursor.style.opacity = '1';
    });
  }
}
